// extracted by mini-css-extract-plugin
module.exports = {"row":"style_row__3RXKg","label":"style_label__2oJkM"};